import { render, staticRenderFns } from "./NuevoCobro.vue?vue&type=template&id=9f563de0&scoped=true"
import script from "./NuevoCobro.vue?vue&type=script&lang=js"
export * from "./NuevoCobro.vue?vue&type=script&lang=js"
import style0 from "./NuevoCobro.vue?vue&type=style&index=0&id=9f563de0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f563de0",
  null
  
)

export default component.exports